import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'quorum-vehicle-diagnostics-shell',
  templateUrl: './vehicle-diagnostics-shell.component.html',
  styleUrls: ['./vehicle-diagnostics-shell.component.scss'],
})
export class VehicleDiagnosticsShellComponent implements OnInit {
  constructor(public route: ActivatedRoute) {}

  ngOnInit(): void {}
}
